import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { getMediaApiPath } from '../../utils/media';

const AuthenticatedImage = ({ source, onLoadError, alt = '', ...props }) => {
  const [objectUrl, setObjectUrl] = useState('');
  const onLoadErrorRef = useRef(onLoadError);

  useEffect(() => {
    onLoadErrorRef.current = onLoadError;
  }, [onLoadError]);

  useEffect(() => {
    let active = true;
    let createdUrl = '';
    const mediaPath = getMediaApiPath(source);
    setObjectUrl('');

    if (!mediaPath) {
      onLoadErrorRef.current?.();
      return () => {};
    }

    api.get(mediaPath, { responseType: 'blob' })
      .then(({ data }) => {
        if (!active) return;
        createdUrl = URL.createObjectURL(data);
        setObjectUrl(createdUrl);
      })
      .catch(() => {
        if (active) onLoadErrorRef.current?.();
      });

    return () => {
      active = false;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [source]);

  if (!objectUrl) return null;
  return <img src={objectUrl} alt={alt} onError={onLoadError} {...props} />;
};

export default AuthenticatedImage;
